import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Design
import { BootstrapModule } from '../design/bootstrap/bootstrap.module';
import { MaterialModule }  from 'src/app/design/material/material.module';

// FontAwesome
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

// PDF viewer
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

// Modals
import { ModalConfirmationComponent } from './components/modal-confirmation/modal-confirmation.component';
import { ModalErrorComponent }        from './components/modal-error/modal-error.component';

// Services
import { ModalService } from './services/modal.service';

@NgModule({

    declarations: [ 
        ModalConfirmationComponent, 
        ModalErrorComponent
    ],

    imports: [
        CommonModule,
        HttpClientModule,
        RouterModule,
        FormsModule,
		ReactiveFormsModule,
        BootstrapModule,
        MaterialModule,
        FontAwesomeModule,
        NgxExtendedPdfViewerModule
    ],

    exports: [
        HttpClientModule,
        RouterModule,
        FormsModule,
		ReactiveFormsModule,
        BootstrapModule,
        MaterialModule,
        FontAwesomeModule,
        NgxExtendedPdfViewerModule
    ],

    entryComponents: [
        ModalConfirmationComponent,
        ModalErrorComponent
    ],

    providers: [
        ModalService
    ]

})

export class SharedModule { 

    constructor(library: FaIconLibrary) {
		library.addIconPacks(fas, fab);
	}

}
